export const ProjectOwnerEnum = {
  User: 'USER',
  Organization: 'ORGANIZATION',
  Global: 'GLOBAL',
} as const;

export type ProjectOwnerEnum = typeof ProjectOwnerEnum[keyof typeof ProjectOwnerEnum];
